import Carousel from '../../../../../UI/Carousel/Carousel'
import { TickIconSVG } from './Icons'
import './Carousel.less'

const ukStatistics = [
  '100% free. Only pay the venue you book',
  "On average you'll hear from 5 venues",
  '9 out of 10 people receive venue messages',
]

interface StatisticsCarouselProps {
  currentIndex?: number
}

const StatisticsCarousel = ({ currentIndex }: StatisticsCarouselProps): JSX.Element => {
  if ('GB' === navigator.language.slice(3, 5)) {
    return (
      <Carousel
        currentIndex={currentIndex}
        className='statistics-carousel'
        aria-label='HeadBox by Numbers - Carousel'>
        {ukStatistics.map((stat) => (
          <p className='carousel-statistic' key={stat}>
            <TickIconSVG aria-hidden='true' />
            {stat}
          </p>
        ))}
      </Carousel>
    )
  }

  return (
    <section className='statistics-carousel'>
      <p className='carousel-statistic'>
        <TickIconSVG aria-hidden='true' />
        <span className='visually-hidden'>And remember: our service is </span>
        {ukStatistics[0]}
      </p>
    </section>
  )
}

export default StatisticsCarousel
